import React from 'react';
import EmptyState from '../common/EmptyState';

const PatronRow = ({ patron, rank }) => {
  const profile = patron.d2f_profiles;
  const name = profile?.display_name || profile?.username || 'Anonymous Fan';
  const avatar = profile?.avatar_url;

  return (
    <div className="flex items-center gap-4 p-4 bg-zinc-900/30 rounded-2xl border border-zinc-800/50 hover:border-white/20 transition-all">
      <span className="text-zinc-700 font-black text-sm w-5 text-center">{rank}</span>
      <div className="w-10 h-10 rounded-full bg-zinc-800 border border-zinc-700 flex-shrink-0 overflow-hidden">
        {avatar ? (
          <img src={avatar} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-sm font-black text-zinc-500">
            {name[0]?.toUpperCase()}
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-black text-white truncate">{name}</p>
        <p className="text-xs text-zinc-500 uppercase font-black tracking-widest mt-0.5">
          ${(patron.total_contributed || 0).toFixed(2)} contributed
        </p>
      </div>
    </div>
  );
};

const PatronsList = ({ patrons }) => {
  if (!patrons?.length) return <EmptyState title="No patrons yet" subtitle="Be the first to support this artist." />;
  return (
    <div className="space-y-3">
      {patrons.map((p, i) => <PatronRow key={p.id} patron={p} rank={i + 1} />)}
    </div>
  );
};

export default PatronsList;